import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

// ─────────────────────────────────────────────────────────────────────────────
// Spinner — the one busy indicator.
//
// There were three spellings: a `Loader2` from lucide with `animate-spin`
// hand-written at sixteen call sites in six different sizes, a hand-rolled
// two-ring `border-t-2` div on the two auth status pages, and a `RefreshCw`
// that spun while refetching. The last one stays where it is: it is a refresh
// affordance whose icon happens to rotate, not a busy indicator, and replacing
// it would delete the meaning of the control.
//
// `Loader2` wins on count and because it is already the icon this app's users
// see. This adds no new look; it gives the look one owner.
//
// `size` is a number rather than a name because the call sites genuinely need
// 12, 14, 16, 18 and 24, and a named scale over five values would be a
// vocabulary with no roles behind it.
//
// It renders `aria-hidden` by default. Almost every call site puts it inside a
// button or beside text that already says what is happening, and a second
// announcement is noise. Pass a `label` where the spinner is the ONLY thing on
// screen, and it becomes a live `role="status"` instead.
// ─────────────────────────────────────────────────────────────────────────────
export function Spinner({
  size = 16,
  className,
  label,
}: {
  size?: number;
  className?: string;
  label?: string;
}) {
  return (
    <Loader2
      size={size}
      className={cn("animate-spin", className)}
      {...(label
        ? { role: "status", "aria-label": label }
        : { "aria-hidden": true })}
    />
  );
}
